import { Component, EventEmitter, Output } from '@angular/core';
import { BasePageComponent, BasePageComponentWithDialogs } from '../../base-page/base-page.component';
import { PendingRewardsService } from 'src/app/services/prizes/pending-rewards.service';
import { take, takeUntil } from 'rxjs';
import { PendingReward } from 'src/app/services/prizes/prizes.models';
import { MatDialog } from '@angular/material/dialog';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { LicenceService } from 'src/app/services/utils/licence.service';

export enum RewardKeys {
  BONUS = "bonus",
  FREESPINS = "freespins"
}

@Component({
  selector: 'app-pending-rewards',
  templateUrl: './pending-rewards.component.html',
  styleUrls: ['./pending-rewards.component.scss']
})
export class PendingRewardsComponent extends BasePageComponentWithDialogs {

  RewardTypes = {
    freeSpins: $localize`:@@pendingRewards.freeSpins:freespins`,
    bonus: $localize`:@@pendingRewards.bonus:bonus`
  }
  successMsg: string = $localize`:@@reward-success: Your reward is now available!`;
  successTitleMsg: string = $localize`:@@reward-success-title: Enjoy your reward!`;
  constructor(
    private pendinRewardsService: PendingRewardsService,
    public errorDialog: MatDialog,
    protected detectDesktopService: DetectDeviceService,
    protected licenceService: LicenceService,
  ) { super(errorDialog, detectDesktopService) }

  prizes: PendingReward[]
  isSubmited = false;
  labelText: string = "";
  RewardKeys = RewardKeys;

  @Output() onAccept: EventEmitter<PendingReward> = new EventEmitter();
  // Emitted from the success dialog's afterClosed, i.e. after the dialog has released and restored page scrolling.
  @Output() successDialogClosed: EventEmitter<void> = new EventEmitter();


  ngOnInit(): void {
    this.isDesktop = this.detectDesktopService.isDesktop();
    this.getRewards();
  }

  getRewards() {
    return this.pendinRewardsService.getPendingRewards().pipe(takeUntil(this.unsubscribe)).subscribe((resp) => {
      this.prizes = resp;
      this.isSubmited = false;
    });
  }

  applyReward(prize: PendingReward) {
    if (this.isSubmited) return;
    this.isSubmited = true;
    this.pendinRewardsService.applyReward(prize.id).pipe(takeUntil(this.unsubscribe)).subscribe({
      next: () => {
        this.onAccept.emit(prize);
        this.getRewards();
        this.openSuccessDialog(this.successMsg,this.successTitleMsg,() => this.successDialogClosed.emit(),null,null,this.licenceService.getKey('icon-bonus-drop'));
      },
      error: () => {
        this.openErrorDialog();
        this.isSubmited = false;
      }
    })
  }
}
